<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <div class="box_loader">
          <div class="loader"></div>
        </div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1 pt-0 mt-0"
        >
          <template v-slot:header>
            <h3 class="mb-0">Crear nuevos estudios</h3>
          </template>
          <div class="card-body">
            <div class="row">
              <div class="col-md-10">
                  <div class="promotion_header">
                    <div class="box_access pt-0">
                      <div class="box_access__item"  ref="create_poll" @click="clickCreatePoll">
                        <div class="icon">
                          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="23" cy="23" r="23" fill="#02A54F" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M18.916 13.0833C18.916 12.6192 19.1004 12.1741 19.4286 11.8459C19.7568 11.5177 20.2019 11.3333 20.666 11.3333H25.3327C25.7968 11.3333 26.2419 11.5177 26.5701 11.8459C26.8983 12.1741 27.0827 12.6192 27.0827 13.0833V14.25C27.0827 14.7141 26.8983 15.1592 26.5701 15.4874C26.2419 15.8156 25.7968 16 25.3327 16H20.666C20.2019 16 19.7568 15.8156 19.4286 15.4874C19.1004 15.1592 18.916 14.7141 18.916 14.25V13.0833ZM20.666 12.5C20.5113 12.5 20.3629 12.5614 20.2535 12.6708C20.1441 12.7802 20.0827 12.9286 20.0827 13.0833V14.25C20.0827 14.4047 20.1441 14.5531 20.2535 14.6625C20.3629 14.7719 20.5113 14.8333 20.666 14.8333H25.3327C25.4874 14.8333 25.6358 14.7719 25.7452 14.6625C25.8546 14.5531 25.916 14.4047 25.916 14.25V13.0833C25.916 12.9286 25.8546 12.7802 25.7452 12.6708C25.6358 12.5614 25.4874 12.5 25.3327 12.5H20.666Z"
                                fill="white" />
                            <path fill-rule="evenodd" style="fill:#fff" clip-rule="evenodd"
                                d="M19.4997 13.0833H16.583C16.1189 13.0833 15.6738 13.2677 15.3456 13.5959C15.0174 13.9241 14.833 14.3692 14.833 14.8333V32.9166C14.833 33.3808 15.0174 33.8259 15.3456 34.1541C15.6738 34.4823 16.1189 34.6666 16.583 34.6666H29.4163C29.8805 34.6666 30.3256 34.4823 30.6538 34.1541C30.982 33.8259 31.1663 33.3808 31.1663 32.9166V14.8333C31.1663 14.3692 30.982 13.9241 30.6538 13.5959C30.3256 13.2677 29.8805 13.0833 29.4163 13.0833H26.4997V14.25C26.4997 14.5594 26.3768 14.8561 26.158 15.0749C25.9392 15.2937 25.6424 15.4166 25.333 15.4166H20.6663C20.3569 15.4166 20.0602 15.2937 19.8414 15.0749C19.6226 14.8561 19.4997 14.5594 19.4997 14.25V13.0833ZM17.7497 21.25C17.7497 21.0953 17.8111 20.9469 17.9205 20.8375C18.0299 20.7281 18.1783 20.6666 18.333 20.6666H22.4163C22.5711 20.6666 22.7194 20.7281 22.8288 20.8375C22.9382 20.9469 22.9997 21.0953 22.9997 21.25C22.9997 21.4047 22.9382 21.5531 22.8288 21.6625C22.7194 21.7719 22.5711 21.8333 22.4163 21.8333H18.333C18.1783 21.8333 18.0299 21.7719 17.9205 21.6625C17.8111 21.5531 17.7497 21.4047 17.7497 21.25ZM18.333 17.75C18.1783 17.75 18.0299 17.8114 17.9205 17.9208C17.8111 18.0302 17.7497 18.1786 17.7497 18.3333C17.7497 18.488 17.8111 18.6364 17.9205 18.7458C18.0299 18.8552 18.1783 18.9166 18.333 18.9166H27.3747C27.5294 18.9166 27.6778 18.8552 27.7872 18.7458C27.8966 18.6364 27.958 18.488 27.958 18.3333C27.958 18.1786 27.8966 18.0302 27.7872 17.9208C27.6778 17.8114 27.5294 17.75 27.3747 17.75H18.333ZM18.9163 25.9166V27.0833H20.083V25.9166H18.9163ZM18.333 24.75C18.1783 24.75 18.0299 24.8114 17.9205 24.9208C17.8111 25.0302 17.7497 25.1786 17.7497 25.3333V27.6666C17.7497 27.8214 17.8111 27.9697 17.9205 28.0791C18.0299 28.1885 18.1783 28.25 18.333 28.25H20.6663C20.8211 28.25 20.9694 28.1885 21.0788 28.0791C21.1882 27.9697 21.2497 27.8214 21.2497 27.6666V25.3333C21.2497 25.1786 21.1882 25.0302 21.0788 24.9208C20.9694 24.8114 20.8211 24.75 20.6663 24.75H18.333ZM27.083 25.9166C27.083 26.3808 26.8986 26.8259 26.5704 27.1541C26.2423 27.4823 25.7971 27.6666 25.333 27.6666C24.8689 27.6666 24.4238 27.4823 24.0956 27.1541C23.7674 26.8259 23.583 26.3808 23.583 25.9166C23.583 25.4525 23.7674 25.0074 24.0956 24.6792C24.4238 24.351 24.8689 24.1666 25.333 24.1666C25.7971 24.1666 26.2423 24.351 26.5704 24.6792C26.8986 25.0074 27.083 25.4525 27.083 25.9166ZM25.333 28.4355C24.1646 28.4355 21.833 29.0573 21.833 30.2916V31.75H28.833V30.2916C28.833 29.0573 26.5014 28.4355 25.333 28.4355Z"
                                fill="white" />
                          </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Crear nueva encuesta</h4>
                          <p class="text">Encuestas de mercado</p>
                        </div>
                      </div>


                      <a class="box_access__item" href="#" ref="create_promo" @click="clickCreateForm">
                        <div class="icon">
                          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="23" cy="23" r="23" fill="#02A54F" />
                            <path style="fill:#fff"
                                d="M23 19V13H17C16.4696 13 15.9609 13.2107 15.5858 13.5858C15.2107 13.9609 15 14.4696 15 15V31C15 31.5304 15.2107 32.0391 15.5858 32.4142C15.9609 32.7893 16.4696 33 17 33H29C29.5304 33 30.0391 32.7893 30.4142 32.4142C30.7893 32.0391 31 31.5304 31 31V21H25C24.4696 21 23.9609 20.7893 23.5858 20.4142C23.2107 20.0391 23 19.5304 23 19ZM18 23.25C18 23.0511 18.079 22.8603 18.2197 22.7197C18.3603 22.579 18.5511 22.5 18.75 22.5C18.9489 22.5 19.1397 22.579 19.2803 22.7197C19.421 22.8603 19.5 23.0511 19.5 23.25C19.5 23.4489 19.421 23.6397 19.2803 23.7803C19.1397 23.921 18.9489 24 18.75 24C18.5511 24 18.3603 23.921 18.2197 23.7803C18.079 23.6397 18 23.4489 18 23.25ZM18 26.25C18 26.0511 18.079 25.8603 18.2197 25.7197C18.3603 25.579 18.5511 25.5 18.75 25.5C18.9489 25.5 19.1397 25.579 19.2803 25.7197C19.421 25.8603 19.5 26.0511 19.5 26.25C19.5 26.4489 19.421 26.6397 19.2803 26.7803C19.1397 26.921 18.9489 27 18.75 27C18.5511 27 18.3603 26.921 18.2197 26.7803C18.079 26.6397 18 26.4489 18 26.25ZM18 29.25C18 29.0511 18.079 28.8603 18.2197 28.7197C18.3603 28.579 18.5511 28.5 18.75 28.5C18.9489 28.5 19.1397 28.579 19.2803 28.7197C19.421 28.8603 19.5 29.0511 19.5 29.25C19.5 29.4489 19.421 29.6397 19.2803 29.7803C19.1397 29.921 18.9489 30 18.75 30C18.5511 30 18.3603 29.921 18.2197 29.7803C18.079 29.6397 18 29.4489 18 29.25ZM21 23.25C21 23.0511 21.079 22.8603 21.2197 22.7197C21.3603 22.579 21.5511 22.5 21.75 22.5H27.25C27.4489 22.5 27.6397 22.579 27.7803 22.7197C27.921 22.8603 28 23.0511 28 23.25C28 23.4489 27.921 23.6397 27.7803 23.7803C27.6397 23.921 27.4489 24 27.25 24H21.75C21.5511 24 21.3603 23.921 21.2197 23.7803C21.079 23.6397 21 23.4489 21 23.25ZM21 26.25C21 26.0511 21.079 25.8603 21.2197 25.7197C21.3603 25.579 21.5511 25.5 21.75 25.5H27.25C27.4489 25.5 27.6397 25.579 27.7803 25.7197C27.921 25.8603 28 26.0511 28 26.25C28 26.4489 27.921 26.6397 27.7803 26.7803C27.6397 26.921 27.4489 27 27.25 27H21.75C21.5511 27 21.3603 26.921 21.2197 26.7803C21.079 26.6397 21 26.4489 21 26.25ZM21 29.25C21 29.0511 21.079 28.8603 21.2197 28.7197C21.3603 28.579 21.5511 28.5 21.75 28.5H27.25C27.4489 28.5 27.6397 28.579 27.7803 28.7197C27.921 28.8603 28 29.0511 28 29.25C28 29.4489 27.921 29.6397 27.7803 29.7803C27.6397 29.921 27.4489 30 27.25 30H21.75C21.5511 30 21.3603 29.921 21.2197 29.7803C21.079 29.6397 21 29.4489 21 29.25ZM24.5 19V13.5L30.5 19.5H25C24.8674 19.5 24.7402 19.4473 24.6464 19.3536C24.5527 19.2598 24.5 19.1326 24.5 19Z"
                                fill="white" />
                          </svg>
                        </div>
                        <div class="body">
                          <h4 class="title">Crear nuevo formulario</h4>
                          <p class="text">Actualización datos de cliente</p>
                        </div>
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
  <CustomModal
      :show="showModal"
      :isHeader="true"
      :isFooter="false"
      :title="titleModal"
      :width="600"
      v-on:modal:close="showModal = $event" >
      <template v-slot:body style="max-width:600px">
        <form @submit.prevent="submiCreateStudio" class="form_laive">
          <div class="box_loader">
            <div class="loader"></div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="col-form-label form-control-label">{{nameInput}}:</label>
              <base-input
                name="user_name"
                placeholder="Nombre"
                required="required"
                minlength="4"
                :value="dataSend.nombreEstudio"
                v-model="dataSend.nombreEstudio"
              ></base-input>
            </div>
            <div class="col-md-12">
              <label class="col-form-label form-control-label">Fecha de Inicio:</label>
              <base-input addon-left-icon="ni ni-calendar-grid-58" name="fechaInicio">
                <flat-picker :config="configDate" class="form-control datepicker" required v-model="dataSend.fechaInicio"></flat-picker>
              </base-input>
            </div>
            <div class="col-md-12">
              <label class="col-form-label form-control-label">Fecha de Fin:</label>
              <base-input addon-left-icon="ni ni-calendar-grid-58" name="fechaFin">
                <flat-picker :config="configDate" class="form-control datepicker" required v-model="dataSend.fechaFin"></flat-picker>
              </base-input>
            </div>
            <div class="col-md-12">
              <base-button type="primary" native-type="submit" class="btn-default my-0">Continuar</base-button>
            </div>
          </div>
        </form>
      </template>
  </CustomModal>
</template>
<script>

import {mapGetters} from 'vuex';
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import CustomModal from "../Components/CustomModal.vue";
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es.js';
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    RouteBreadCrumb,
    CustomModal,
    flatPicker
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },
  methods: {
    clickCreatePoll(event){
      const select = this.$refs.create_poll
      this.type = "Crear Encuesta"
      this.nameInput = "Nombre de la encuesta"
      this.titleModal = 'Creación de nueva encuesta'
      this.showModal =true;
    },
    clickCreateForm(event){
      this.type = "Crear Formulario"
      this.nameInput = "Nombre del formulario"
      this.titleModal = 'Creación de nuevo formulario'
      this.showModal =true;
    },
    submiCreateStudio(){
      const $this = this
      console.log($this.dataSend)
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      document.querySelector(".form_laive").classList.add("validateClient")
      axios.post(process.env.VUE_APP_API_URL+"/estudio/crear", $this.dataSend,config)
      .then(function (response){
        setTimeout(() => {
          document.querySelector(".form_laive").classList.remove("validateClient")
          let dataStudio = response.data
          console.log({dataStudio})
          $this.showModal = false;
          $this.$router.replace({ name: $this.type, params: {id:dataStudio.idEstudio}, query: {
            inicio: $this.dataSend.fechaInicio,
            fin: $this.dataSend.fechaFin
            }})
        }, 2000);
      })

    }
  },
  data() {
    return {
      titleModal: "",
      showModal:false,
      nameInput: "Nombre de la encuesta",
      dataSend:{
        nombreEstudio: "",
        fechaInicio: "",
        fechaFin: ""
      },
      type: "",
      configDate: {
        altInput: true,
        allowInput: true,
        locale: Spanish, // locale for this instance only
      },
    };
  },
}
</script>
